import { useState, useEffect, useRef, Fragment, useContext, memo } from 'react'
import { SocketContext } from '@src/utility/context/Socket'
import Avatar from '@components/avatar'
import { useDispatch, useSelector } from 'react-redux'
import {
    recieveMsgRD,
    storeMessagesInRedux,
    addRdContactsInRedux,
    sendMsgRD,
    uploadMediaToserver,
    saveTemplete,
    archiveConversation,
    unarchiveConversation,
    markConversationUnread
} from './store/actions'
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import CustomAvatar from '@src/views/components/CustomAvatar'
import {
    MessageSquare,
    Paperclip,
    FileText,
    File,
    ChevronLeft,
    Send,
    Image,
    X,
    User,
    MoreVertical,
    Mail,
    Clock,
    Plus
} from 'react-feather'
import {
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Form,
    Label,
    InputGroup,
    InputGroupAddon,
    Input,
    InputGroupText,
    Button,
    UncontrolledButtonDropdown,
    UncontrolledDropdown,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    FormGroup,
    Spinner,
    Row,
    Col
} from 'reactstrap'
import { ArchiveIcon, UnarchiveIcon } from '@src/views/components/ArchiveIcons'
import BlankLogo from "@src/assets/images/avatars/Blank-logo.jpg"
import { allowedFiles, allowedFilesErrorMessages } from '@src/utility/Utils'
import { Link } from "react-router-dom"
import { Slide, toast } from "react-toastify"
import draftToHtml from "draftjs-to-html"
import { ContentState, convertToRaw, EditorState } from "draft-js"
import { Editor } from "react-draft-wysiwyg"
import '@styles/react/libs/editor/editor.scss'
import '@styles/base/plugins/forms/form-quill-editor.scss'
import htmlToDraft from "html-to-draftjs"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { PropTypes } from "prop-types"
import useMessageFollowUp, { formatMonthYear } from '@src/views/components/hooks/useMessageFollowUp'
import SampleSurveyCard from './SampleSurveyCard'

const ChatLog = props => {
    const ps = useRef([])
    const attachmets = useRef(null)
    const {
        handleUser,
        handleUserSidebarRight,
        handleSidebar,
        store,
        userSidebarLeft,
        selectedUserID,
        selectedUserRdChat,
        currentUser,
        onTabChange,
        activeTab
    } = props
    const { userProfile, selectedUser, rdContacts, rdChatWithBrands, selectedRdContactDetail } = store
    const rdChatStoreSlice = useSelector(state => state.chatRd)
    const chatArea = useRef(null)
    const dispatch = useDispatch()
    const socket = useContext(SocketContext)

    const sweetAlert = withReactContent(Swal)

    const chatMessages = selectedUserRdChat?.data || []
    const currentUserId = currentUser?.chat_id || currentUser?.id
    const otherUserChatId = selectedRdContactDetail?.chat_user
    const { showFollowUp, daysSince, isLongWait, lastMessageDate, monthYear } = useMessageFollowUp(chatMessages, currentUserId, otherUserChatId)

    const isThreadArchived = Boolean(
        selectedRdContactDetail?.is_archived === true ||
        selectedRdContactDetail?.is_archived === 1 ||
        selectedRdContactDetail?.is_archived === '1' ||
        selectedRdContactDetail?.is_archived === 'true' ||
        selectedRdContactDetail?.is_auto_archived === true ||
        (store?.archiveContacts?.data || []).some(item => {
            const id = item?.chat_user || item?.user_id
            return id != null && otherUserChatId != null && String(id) === String(otherUserChatId)
        })
    )

    // Helper: format WhatsApp-style timestamp — always 12-hour AM/PM
    const formatMsgTime = (timezone) => {
        if (!timezone) return ''
        const d = new Date(timezone)
        if (isNaN(d.getTime())) return timezone

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())
        const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })

        if (msgDate.getTime() === today.getTime()) {
            return `Today, ${timeStr}`
        } else if (msgDate.getTime() === yesterday.getTime()) {
            return `Yesterday, ${timeStr}`
        } else {
            const dateStr = d.toLocaleDateString([], { month: 'short', day: 'numeric' })
            return `${dateStr}, ${timeStr}`
        }
    }

    // Helper: format month + year for long-wait banner
    const formatMonthYear = (date) => {
        if (!date) return ''
        return date.toLocaleDateString([], {month: 'long', year: 'numeric'})
    }

    // Helper: determine if a brand is inactive / no longer available (handles false, 0, '0', 'false')
    const isBrandInactive = (item) => {
        if (!item) return false
        if (item.brand_is_paid === false || item.brand_is_paid === 0 || item.brand_is_paid === '0' || item.brand_is_paid === 'false') {
            return true
        }
        if (item.is_paid === false || item.is_paid === 0 || item.is_paid === '0' || item.is_paid === 'false') {
            return true
        }
        if (item.is_active === false || item.is_active === 0 || item.is_active === '0' || item.is_active === 'false') {
            return true
        }
        if (item.brand_is_active === false || item.brand_is_active === 0 || item.brand_is_active === '0' || item.brand_is_active === 'false') {
            return true
        }
        return false
    }

    // Helper: format header subtitle status
    const getHeaderSubtitle = () => {
        if (!selectedRdContactDetail) return null
        if (isBrandInactive(selectedRdContactDetail)) {
            return <small className='text-danger text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Brand no longer available</small>
        }
        if (selectedRdContactDetail?.status === 0 || selectedRdContactDetail?.status === '0' || selectedRdContactDetail?.is_active === 0 || selectedRdContactDetail?.is_active === '0') {
            return <small className='text-danger text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>Account is blocked</small>
        }
        const lastMsg = (chatMessages && chatMessages.length > 0) ? chatMessages[chatMessages.length - 1] : null
        const rawDate = lastMsg?.created_at || lastMsg?.timezone || selectedRdContactDetail?.last_message_created_at || selectedRdContactDetail?.created_at || selectedRdContactDetail?.last_message_timezone || selectedRdContactDetail?.timezone || selectedRdContactDetail?.last_message_time
        if (!rawDate) {
            return <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>No messages yet</small>
        }
        const dateObj = new Date(rawDate)
        const isValidDate = !isNaN(dateObj.getTime())
        if (!isValidDate) {
            return null
        }

        const timeStr = dateObj.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })
        const dateStr = dateObj.toLocaleDateString([], { day: 'numeric', month: 'short' })
        const subtitleText = `Last message · ${dateStr}, ${timeStr}`

        return (
            <small className='text-muted text-truncate d-block' style={{ fontSize: '11px', lineHeight: '1.2' }}>
                {subtitleText}
            </small>
        )
    }

    const [msg, setMsg] = useState('')
    const [questate, setQueState] = useState({ inQueFilePreview: "", inQueFile: "" })
    const [selectedFile, setSelectedFile] = useState(null)
    const [isFilePicked, setIsFilePicked] = useState(false)
    const [isOpenTempleteModal, setIsOpenTempleteModal] = useState(false)
    const [templeteTitle, setTempleteTitle] = useState(null)
    const [fileUploadError, setFileUploadError] = useState(false)
    const [sendMsgLoader, setSendMsgLoader] = useState(false)
    const [msgEditorState, setMsgEditorState] = useState(null)
    const [showTemplateBar, setShowTemplateBar] = useState(false)
    const templateBarRef = useRef(null)

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (templateBarRef.current && !templateBarRef.current.contains(event.target)) {
                setShowTemplateBar(false)
            }
        }
        if (showTemplateBar) {
            document.addEventListener('mousedown', handleClickOutside)
            document.addEventListener('touchstart', handleClickOutside)
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            document.removeEventListener('touchstart', handleClickOutside)
        }
    }, [showTemplateBar])

    const scrollToBottom = () => {
        if (chatArea.current) {
            chatArea.current.scrollTop = chatArea.current.scrollHeight
        }
    }

    useEffect(() => {
        socket.on('connect', (error) => {
            if (error) {
                alert(error)
            }
        })
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        socket.emit('join', user, (error) => {
        })
        // socket.emit('chat message', 'mesge here will send to server')
        if (selectedUserID) {
            const selectedChatBrandContact = JSON.parse(localStorage.getItem('selectedChatBrand'))
            dispatch(addRdContactsInRedux({ chat_user: parseInt(selectedUserID), ...selectedChatBrandContact }))
        }
    }, [])

    // ** If user chat is not empty scrollToBottom
    useEffect(() => {
        if (selectedRdContactDetail) {
            const selectedUserLen = Object.keys(selectedRdContactDetail).length
            if (selectedUserLen) {
                scrollToBottom()
            }
        }

        if (rdChatStoreSlice?.rdMessageResponse) {
            setSendMsgLoader(false)
            if (rdChatStoreSlice?.rdMessageResponse?.status) {
                toast.success(
                    <Fragment>
                        <div className='toastify-header'>
                            <div className='title-wrapper'>
                                <Avatar size='sm' color='success' icon={<MessageSquare size={12} />} />
                                <h6 className='toast-title font-weight-bold'>Success</h6>
                            </div>
                        </div>
                        <div className='toastify-body'>
                            <span>{rdChatStoreSlice?.rdMessageResponse?.msg}</span>
                        </div>
                    </Fragment>, { transition: Slide, hideProgressBar: true, autoClose: 5000 })
            } else {
                toast.error(<Fragment>{rdChatStoreSlice?.rdMessageResponse?.msg}</Fragment>, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 5000
                })
            }
            setMsg("")
            setMsgEditorState(null)
            dispatch({ type: "SEND_MSG_SUCCESS_RESPONSE_RD_NULL" })
        }

        const error = rdChatStoreSlice?.rdChatLoadError?.response?.status
        if (error && error !== 401) {
            sweetAlert.fire({
                title: 'Connection Error!',
                icon: 'error',
                html: '<p>Please reload the page.</p>',
                confirmButtonText: 'Reload',
                allowOutsideClick: false,
                showCancelButton: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload()
                }
            })
            dispatch({ type: "RD_CHAT_LOAD_ERROR_RESET" })
            dispatch({ type: "RD_SELECTED_USER_CHAT_LOADER_RESET" })
        }
    }, [rdChatStoreSlice])

    useEffect(() => {
        socket.on('new-user-message', (data) => {

            const receivedMessage = {
                message: data.data.message,
                media: data.data.media,
                from_user_id: data.data.from_user_id,
                to_user_id: data.data.to_user_id
            }
            dispatch(recieveMsgRD(receivedMessage))
        })

    }, [])

    // --- Send message and media ---
    const handleSendMsg = (e) => {
        e.preventDefault()
        setSendMsgLoader(true)
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedRdContactDetail.chat_user
        const date = new Date()
        const objTest = {
            chat: [],
            selectedRd: selectedUserID
        }
        const msgObj = {
            message: msg,
            from_user_id: user?.chat_id,
            to_user_id: receiver_id,
            timezone: date.toString()
        }
        objTest.chat.push(msgObj)
        dispatch(storeMessagesInRedux(objTest))
        dispatch(sendMsgRD(msgObj))
        socket.emit("new-message", msgObj)

        if (selectedFile) {
            const media = {
                to_user_id: receiver_id,
                file: selectedFile,
                from_user_id: user.chat_id,
                timezone: date.toString(),
                socket
            }
            dispatch(uploadMediaToserver(media))
            setQueState(prevState => ({
                ...prevState,
                inQueFilePreview: '',
                inQueFile: ''
            }))
            setSelectedFile(null)
        }
    }

    const getBase64 = (img, callback) => {
        if (img) {
            const reader = new FileReader()
            reader.addEventListener('load', () => callback(reader.result))
            reader.readAsDataURL(img)
        }
    }

    const changeHandler = (event) => {
        const receiver_id = selectedRdContactDetail.chat_user
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        setFileUploadError(false)
        const file = event.target.files[0]
        if (!file) return
        if (allowedFiles().includes(file.name?.split('.').pop().toLowerCase())) {
            setSelectedFile(file)
            getBase64(file, imageUrl => {
                setQueState(prevState => ({
                    ...prevState,
                    inQueFilePreview: imageUrl,
                    inQueFile: file
                }))
            })
            setIsFilePicked(true)
        } else {
            setSelectedFile(null)
            setQueState({
                inQueFilePreview: '',
                inQueFile: ''
            })
            setFileUploadError(true)
        }
    }

    const handleTitle = (event) => {
        setTempleteTitle(event.target.value)
    }

    const handleMessageTemplete = () => {
        const user = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
        const receiver_id = selectedRdContactDetail.chat_user
        const objTest = {
            chat: [],
            selectedRd: selectedUserID
        }
        if (msg.length !== 0) {
            if (templeteTitle !== null) {
                const msgTemplete = {
                    message: msg,
                    title: templeteTitle
                }
                dispatch(saveTemplete(msgTemplete))
                // setMsg("")
                setTempleteTitle("")
                setIsOpenTempleteModal(false)

            } else {
                alert('Template title is required.')
            }
        } else {
            alert('Message field is required.')
            setIsOpenTempleteModal(false)

        }
    }

    const appendTemplete = (item) => {
        const content = htmlToDraft(item.template)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        setMsgEditorState(EditorState.createWithContent(contentState))
        setMsg(item.template)
    }

    const handleFollowUpClick = () => {
        const defaultFollowUp = '<p>Hi! Just following up on my previous message to see if you had any questions.</p>'
        const content = htmlToDraft(defaultFollowUp)
        const contentState = ContentState.createFromBlockArray(content?.contentBlocks)
        setMsgEditorState(EditorState.createWithContent(contentState))
        setMsg(defaultFollowUp)
    }

    // Helper: extract date string key for date divider grouping
    const getDateKey = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }

    // Helper: format center date divider banner (e.g. Jun 17, 2026 / Today / Yesterday)
    const formatDateDivider = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return rawTime

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)

        const msgDate = new Date(d.getFullYear(), d.getMonth(), d.getDate())

        if (msgDate.getTime() === today.getTime()) {
            return 'Today'
        }
        if (msgDate.getTime() === yesterday.getTime()) {
            return 'Yesterday'
        }
        return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
    }

    // Helper: format time only (e.g. 9:14 AM or 11:32 AM)
    const formatTimeOnly = (rawTime) => {
        if (!rawTime) return ''
        const d = new Date(rawTime)
        if (isNaN(d.getTime())) return ''
        return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
    }

    // ** Renders user chat
    const renderChats = () => {
        const rawChatData = selectedUserRdChat?.data || []

        // Find the latest message ID for each participate_request_id so only ONE active card renders
        const latestSurveyMsgIdMap = {}
        rawChatData.forEach(msg => {
            if (msg.message_type === 'sample_survey') {
                const key = msg.participate_request_id || 'default'
                latestSurveyMsgIdMap[key] = msg.msg_id || msg.id
            }
        })

        // Filter out older duplicate sample_survey messages completely
        const chatData = rawChatData.filter(msg => {
            if (msg.message_type === 'sample_survey') {
                const key = msg.participate_request_id || 'default'
                return latestSurveyMsgIdMap[key] === (msg.msg_id || msg.id)
            }
            return true
        })

        return chatData.map((item, index) => {
            const otherId = parseInt(selectedRdContactDetail?.chat_user)
            const isSentByMe = parseInt(item?.to_user_id) === otherId || (parseInt(item?.from_user_id) !== otherId && !isNaN(parseInt(item?.from_user_id)))
            const senderName = isSentByMe ? 'You' : (selectedRdContactDetail?.brand_name || 'Them')
            const timeOnly = formatTimeOnly(item.timezone || item.created_at)
            const timeLabel = `${senderName} · ${timeOnly}`
            const isLatestSurveyMsg = item.message_type === 'sample_survey' && latestSurveyMsgIdMap[item.participate_request_id || 'default'] === (item.msg_id || item.id)

            const currentDateKey = getDateKey(item.timezone || item.created_at)
            const prevDateKey = index > 0 ? getDateKey(chatData[index - 1].timezone || chatData[index - 1].created_at) : null
            const showDateDivider = currentDateKey && currentDateKey !== prevDateKey

            return (
                <Fragment key={index}>
                    {showDateDivider && (
                        <div className='chat-date-divider text-center my-1 w-100'>
                            <span>
                                {formatDateDivider(item.timezone || item.created_at)}
                            </span>
                        </div>
                    )}
                    <div
                        ref={(el) => (ps.current[index] = el)}
                        className={classnames('chat', {
                            'chat-left': !isSentByMe
                        })}
                    >
                        <div className="chat-body">
                            {/* Sender Name + Time ABOVE Bubble */}
                            <div className={classnames('chat-meta-top mb-25', {
                                'text-right': isSentByMe,
                                'text-left': !isSentByMe
                            })}>
                                <span>
                                    {timeLabel}
                                </span>
                            </div>

                            {/* Message Content */}
                            {item.media ? (
                                <div className="chat-content media-file">
                                    {item.message_type === "img" && (
                                        <div>
                                            <img src={item.media} height="200" title={item.file_name} alt={item.file_name} />
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                                style={{ textDecoration: "underline" }}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "pdf" && (
                                        <div>
                                            <File size={100} style={{ color: '#56B6FF' }} />
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                                style={{ textDecoration: "underline" }}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                    {item.message_type === "doc" && (
                                        <div>
                                            <File size={100} style={{ color: '#56B6FF' }} />
                                            <p className="mt-2 text-primary font-small-2 text-center cursor-pointer"
                                                style={{ textDecoration: "underline" }}>
                                                <a href={item.media} target="_blank">Download</a>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : item.message_type === 'sample_survey' ? (
                                // Milestone 5: Render interactive survey card inline
                                <SampleSurveyCard
                                    message={item}
                                    participateRequestId={item.participate_request_id}
                                />
                            ) : (
                                <div className="chat-content">
                                    <div dangerouslySetInnerHTML={{ __html: item.message }}></div>
                                </div>
                            )}
                        </div>
                    </div>
                </Fragment>
            )
        })
    }
    // ** Opens right sidebar & handles its data
    const handleAvatarClick = obj => {
        handleUserSidebarRight()
        handleUser(obj)
    }
    // ** On mobile screen open left sidebar on Start Conversation Click
    const handleStartConversation = () => {
        if (!Object.keys(selectedUser)?.length && !userSidebarLeft && window.innerWidth <= 1200) {
            handleSidebar()
        }
    }
    // ** ChatWrapper tag based on chat's length
    const ChatWrapper = selectedRdContactDetail && selectedUserRdChat ? PerfectScrollbar : 'div'

    return (
        <Fragment>
            <div className="chat-app-window w-100 chat-rd">
                <div
                    className={classnames("start-chat-area", {
                        "d-none": !!selectedRdContactDetail
                    })}
                >
                    <div className="start-chat-icon mb-1">
                        <MessageSquare />
                    </div>
                    <h4 className="sidebar-toggle start-chat-text text-center">
                        <button className='btn p-0' onClick={handleStartConversation}>
                            <span>Select a Brand to Start Your First Chat. </span>
                            <span style={{ textDecoration: 'underline' }} className="text-primary d-sm-none">Tap Here</span>
                        </button>
                    </h4>
                </div>
                <div
                    className={classnames("active-chat", {
                        "d-none": selectedRdContactDetail === null
                    })}
                >
                    <div className="chat-navbar">
                        <header className="chat-header justify-content-between">
                            <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                <div className="sidebar-toggle d-block d-lg-none mr-1">
                                    <button className='btn btn-link p-0' onClick={handleSidebar}>
                                        <ChevronLeft size={21} />
                                    </button>
                                </div>
                                {selectedRdContactDetail && (
                                    <Link
                                        to={`/dashboard/rd/brands/${selectedRdContactDetail?.brand_id}`}
                                        className='d-flex align-items-center text-body ml-25 overflow-hidden'
                                        title='View brand profile'
                                    >
                                        <CustomAvatar
                                            name={selectedRdContactDetail?.brand_name}
                                            img={selectedRdContactDetail?.brand_logo || selectedRdContactDetail?.company_logo}
                                            imgHeight='36'
                                            imgWidth='36'
                                            className='mr-50 flex-shrink-0'
                                        />
                                        <div className='d-flex flex-column justify-content-center overflow-hidden'>
                                            <h6 className='mb-0 font-weight-bold text-truncate' style={{ lineHeight: '1.2', fontSize: '13px' }}>
                                                {selectedRdContactDetail?.brand_name}
                                            </h6>
                                            {getHeaderSubtitle()}
                                        </div>
                                    </Link>
                                )}
                            </div>

                            {/* Header Actions — Right Side */}
                            {selectedRdContactDetail && (
                                <div className='d-flex align-items-center ml-1' style={{ gap: '6px' }}>
                                    {/* Profile Button — desktop view */}
                                    <Link
                                        to={`/dashboard/rd/brands/${selectedRdContactDetail?.brand_id}`}
                                        className='btn btn-outline-secondary btn-icon btn-sm d-none d-md-inline-flex align-items-center justify-content-center chat-header-action-btn'
                                        title='View Profile'
                                        style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                    >
                                        <User size={16} />
                                    </Link>

                                    {/* Archive / Unarchive Button — desktop view */}
                                    {isThreadArchived ? (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Unarchive this thread?',
                                                    text: 'It will be moved back to your Inbox.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Unarchive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(unarchiveConversation(selectedRdContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('inbox')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <UnarchiveIcon size={14} className='mr-25' />
                                            <span>Unarchive</span>
                                        </Button>
                                    ) : (
                                        <Button
                                            outline
                                            color='secondary'
                                            size='sm'
                                            className='d-none d-md-inline-flex align-items-center chat-header-action-btn'
                                            style={{ height: '34px', borderRadius: '8px', padding: '0 10px', fontSize: '12px' }}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedRdContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            <ArchiveIcon size={14} className='mr-25' />
                                            <span>Archive</span>
                                        </Button>
                                    )}

                                    {/* 3-Dot Dropdown Menu */}
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            color='outline-secondary'
                                            size='sm'
                                            className='btn-icon chat-header-action-btn d-flex align-items-center justify-content-center'
                                            style={{ width: '34px', height: '34px', padding: 0, borderRadius: '8px' }}
                                        >
                                            <MoreVertical size={16} />
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            {/* Mobile-only responsive fallbacks */}
                                            <DropdownItem
                                                tag={Link}
                                                to={`/dashboard/rd/brands/${selectedRdContactDetail?.brand_id}`}
                                                className='d-flex d-md-none align-items-center'
                                            >
                                                <User size={14} className='mr-50' />
                                                <span>View Profile</span>
                                            </DropdownItem>
                                            {isThreadArchived ? (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Unarchive this thread?',
                                                            text: 'It will be moved back to your Inbox.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Unarchive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(unarchiveConversation(selectedRdContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('inbox')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <UnarchiveIcon size={14} className='mr-50' />
                                                    <span>Unarchive Thread</span>
                                                </DropdownItem>
                                            ) : (
                                                <DropdownItem
                                                    className='d-flex d-md-none align-items-center'
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        sweetAlert.fire({
                                                            title: 'Archive this thread?',
                                                            text: 'It will be moved to your Archive tab.',
                                                            icon: 'question',
                                                            showCancelButton: true,
                                                            confirmButtonText: 'Archive',
                                                            cancelButtonText: 'Cancel'
                                                        }).then(result => {
                                                            if (result.isConfirmed) {
                                                                dispatch(archiveConversation(selectedRdContactDetail?.chat_user))
                                                                if (onTabChange) {
                                                                    onTabChange('archive')
                                                                }
                                                            }
                                                        })
                                                    }}
                                                >
                                                    <ArchiveIcon size={14} className='mr-50' />
                                                    <span>Archive Thread</span>
                                                </DropdownItem>
                                            )}

                                            {/* Non-redundant action: Mark as Unread */}
                                            <DropdownItem
                                                className='d-flex align-items-center'
                                                onClick={() => {
                                                    dispatch(markConversationUnread(selectedRdContactDetail?.chat_user))
                                                    toast.success('Conversation marked as unread')
                                                }}
                                            >
                                                <Mail size={14} className='mr-50' />
                                                <span>Mark as Unread</span>
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            )}
                        </header>
                    </div>
                    <ChatWrapper
                        containerRef={ref => {
                            chatArea.current = ref
                        }}
                        className="user-chats"
                        options={{ wheelPropagation: false }}
                    >
                        <div className="chats">
                            {rdChatStoreSlice?.selectedUserRDChatLoading ? (
                                /* Skeleton loader — alternating left/right bubbles */
                                <div className="chat-skeleton-loader px-1 py-1">
                                    {[true, false, true, false, true].map((isRight, i) => (
                                        <div key={i} className={`chat-skeleton-row ${isRight ? 'right' : 'left'}`}>
                                            {!isRight && <div className="skeleton-avatar-sm" />}
                                            <div className="skeleton-bubble" style={{width: `${45 + (i % 3) * 15}%`}} />
                                            {isRight && <div className="skeleton-avatar-sm" />}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <Fragment>{renderChats()}</Fragment>
                            )}
                        </div>
                    </ChatWrapper>
                    <div className="bg-white d-block chat-bottom-wrapper">
                        {fileUploadError &&
                            <div className="validation-err ml-1">{allowedFilesErrorMessages().IMAGE_AND_FILES} </div>}
                        {!rdChatStoreSlice?.selectedUserRDChatLoading && isBrandInactive(selectedRdContactDetail) && (
                            <div className="chat-brand-unavailable-banner">
                                This brand is no longer available.
                            </div>
                        )}
                        {!rdChatStoreSlice?.selectedUserRDChatLoading && showFollowUp && !isThreadArchived && !isBrandInactive(selectedRdContactDetail) && (
                            <div className="chat-followup-banner">
                                <div className="chat-followup-banner-content">
                                    <Clock size={16} className='flex-shrink-0' style={{ color: '#7c2d12' }} />
                                    <span className='banner-text'>
                                        {daysSince >= 30
                                            ? `You replied in ${monthYear || formatMonthYear(lastMessageDate)} — still waiting on ${selectedRdContactDetail?.brand_name || 'brand'}. Would you like to follow up?`
                                            : `You replied ${daysSince === 1 ? '1 day' : `${daysSince} days`} ago — still waiting on ${selectedRdContactDetail?.brand_name || 'brand'}. Would you like to follow up?`}
                                    </span>
                                </div>
                                <div className="chat-followup-actions">
                                    <button
                                        type='button'
                                        className='btn btn-followup-banner'
                                        onClick={handleFollowUpClick}
                                    >
                                        Follow up
                                    </button>
                                    {!isThreadArchived && (
                                        <button
                                            type='button'
                                            className='btn btn-archive-banner'
                                            onClick={() => {
                                                sweetAlert.fire({
                                                    title: 'Archive this thread?',
                                                    text: 'It will be moved to your Archive tab.',
                                                    icon: 'question',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Archive',
                                                    cancelButtonText: 'Cancel'
                                                }).then(result => {
                                                    if (result.isConfirmed) {
                                                        dispatch(archiveConversation(selectedRdContactDetail?.chat_user))
                                                        if (onTabChange) {
                                                            onTabChange('archive')
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            Archive
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                        <Form className="chat-app-form" onSubmit={(e) => handleSendMsg(e)}>
                            <Row>
                                <Col xs={12} lg={12}>
                                    <Editor
                                        editorState={msgEditorState}
                                        placeholder="Write a message..."
                                        onEditorStateChange={(e) => {
                                            setMsgEditorState(e)
                                            const contentState = e.getCurrentContent()
                                            if (contentState.hasText()) {
                                                setMsg(draftToHtml(convertToRaw(e.getCurrentContent())))
                                            } else {
                                                setMsg('')
                                            }
                                        }}
                                        toolbar={{
                                            options: ['inline', 'list', 'link'],
                                            inline: {
                                                options: ['bold', 'italic', 'underline']
                                            },
                                            list: {
                                                options: ['unordered', 'ordered']
                                            },
                                            link: {
                                                popupClassName: 'msg-editor-link-and-img',
                                                showOpenOptionOnHover: false
                                            }
                                        }}
                                        editorClassName='msg-editor'
                                        stripPastedStyles={true}
                                        readOnly={isBrandInactive(selectedRdContactDetail)}
                                    />
                                </Col>
                                <Col xs={12} lg={12} className="d-flex justify-content-between align-items-center mt-1 pt-75 border-top">
                                    <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                        <Label
                                            className="btn-chat-icon-action mb-0 cursor-pointer"
                                            htmlFor="attach-doc"
                                            title="Attach file (PDF, Image, Doc)"
                                        >
                                            <Paperclip size={18} />
                                            <input type="file"
                                                id="attach-doc"
                                                accept=".pdf, .png, .jpg, .jpeg, .doc, .docx, .xlsx, .xls"
                                                onChange={changeHandler}
                                                hidden={true}
                                                disabled={sendMsgLoader}
                                            />
                                        </Label>

                                        {/* Template Icon Button & Animated Menu with Click-Outside Ref */}
                                        <div ref={templateBarRef} className="d-flex align-items-center" style={{ gap: '6px' }}>
                                            <button
                                                type="button"
                                                className={classnames("btn-chat-icon-action", { active: showTemplateBar })}
                                                title="Message Templates"
                                                onClick={() => setShowTemplateBar(!showTemplateBar)}
                                            >
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                    <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                                                    <line x1="8" y1="4" x2="8" y2="20"></line>
                                                    <line x1="12" y1="9" x2="18" y2="9"></line>
                                                    <line x1="12" y1="15" x2="18" y2="15"></line>
                                                </svg>
                                            </button>

                                            {/* Animated 2-Tag Option Menu with Cross Icon */}
                                            {showTemplateBar && (
                                                <div className="chat-template-action-bar">
                                                    <UncontrolledButtonDropdown direction="up">
                                                        <DropdownToggle
                                                            tag="button"
                                                            className="btn-template-tag"
                                                        >
                                                            <FileText size={13} />
                                                            <span>Templates</span>
                                                        </DropdownToggle>
                                                        <DropdownMenu className='msg-template-dropdown' style={{ minWidth: '220px' }}>
                                                            <DropdownItem header className="font-weight-bold">Select Template</DropdownItem>
                                                            {rdChatStoreSlice?.rdMessageTempletes?.data && rdChatStoreSlice?.rdMessageTempletes?.data.length > 0 ? (
                                                                rdChatStoreSlice?.rdMessageTempletes?.data.map((item, index) => (
                                                                    <DropdownItem onClick={() => { appendTemplete(item); setShowTemplateBar(false); }} key={index}>
                                                                        {index + 1}. {item?.title?.length > 25 ? `${item?.title.substring(0, 25)}...` : item?.title}
                                                                    </DropdownItem>
                                                                ))
                                                            ) : (
                                                                <DropdownItem disabled className="text-muted small">No saved templates</DropdownItem>
                                                            )}
                                                        </DropdownMenu>
                                                    </UncontrolledButtonDropdown>

                                                    <button
                                                        type="button"
                                                        className="btn-template-save-tag"
                                                        onClick={() => {
                                                            setIsOpenTempleteModal(true)
                                                            setShowTemplateBar(false)
                                                        }}
                                                        disabled={sendMsgLoader}
                                                    >
                                                        <Plus size={13} />
                                                        <span>Save Template</span>
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn-template-close-tag"
                                                        onClick={() => setShowTemplateBar(false)}
                                                        title="Close"
                                                    >
                                                        <X size={13} />
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {questate.inQueFilePreview && (
                                            <div className="badge badge-light-primary d-flex align-items-center py-50 px-75 rounded-pill">
                                                {selectedFile?.type === "application/pdf" ? (
                                                    <FileText size="14" className="mr-50 text-primary" />
                                                ) : (
                                                    <Image size="14" className="mr-50 text-primary" />
                                                )}
                                                <span className="text-truncate mr-50 font-weight-bold" style={{ maxWidth: '140px', fontSize: '12px' }}>
                                                    {selectedFile?.name || 'Attached file'}
                                                </span>
                                                <X size={14}
                                                   className="cursor-pointer text-danger ml-25"
                                                   title="Remove attachment"
                                                   onClick={() => {
                                                       setQueState({ inQueFilePreview: '', inQueFile: '' })
                                                       setSelectedFile(null)
                                                   }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center">
                                        <Button
                                            color="primary"
                                            id="send-message"
                                            disabled={sendMsgLoader || msg.length === 0}
                                            size="sm"
                                            className="d-flex align-items-center"
                                        >
                                            {sendMsgLoader ? (
                                                <Spinner style={{ height: '14px', width: '14px' }} />
                                            ) : (
                                                <Fragment>
                                                    <Send size={15} className="mr-50" />
                                                    <span>Send</span>
                                                </Fragment>
                                            )}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
            </div>
            <Modal isOpen={isOpenTempleteModal} className='modal-dialog-centered'>
                <ModalHeader>Message Template</ModalHeader>
                <ModalBody style={{ minHeight: '50px' }}>
                    <FormGroup className='mb-2'>
                        <Label htmlFor='coupon-code'>Title</Label>
                        <Input type='text' placeholder='Templete Title' id='title'
                            name="title"
                            value={templeteTitle}
                            onChange={e => handleTitle(e)}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color='danger' outline onClick={() => setIsOpenTempleteModal(!isOpenTempleteModal)}>
                        Cancel
                    </Button>
                    <Button color='primary' onClick={() => handleMessageTemplete()}>
                        Save
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}

ChatLog.propTypes = {
    handleUser: PropTypes.func,
    handleUserSidebarRight: PropTypes.func,
    handleSidebar: PropTypes.func,
    store: PropTypes.shape({
        userProfile: PropTypes.object,
        selectedUser: PropTypes.object,
        rdContacts: PropTypes.arrayOf(
            PropTypes.shape({
                chat_user: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        ),
        rdChatWithBrands: PropTypes.arrayOf(
            PropTypes.shape({})
        ),
        selectedRdContactDetail: PropTypes.shape({
            chat_user: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            brand_logo: PropTypes.string
        })
    }),
    userSidebarLeft: PropTypes.bool,
    selectedUserID: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    selectedUserRdChat: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                message: PropTypes.string,
                media: PropTypes.string,
                from_user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                to_user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                message_type: PropTypes.string,
                file_name: PropTypes.string,
                send_by: PropTypes.string,
                brand_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            })
        )
    }),
    currentUser: PropTypes.shape({
        profile_img: PropTypes.string,
        profile_image: PropTypes.string
    })
}

export default memo(ChatLog)